import {defaultUiSchema} from "../ui-schema/default.ui.schema";

export const mappingUiSchema = defaultUiSchema;
